import e from "react";
import r from "./index75.mjs";
import a from "./index76.mjs";
const o = e.forwardRef((d, t) => /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": "loader-container",
    className: a.loader_container,
    ref: t
  },
  /* @__PURE__ */ e.createElement("div", { "data-testid": "loader-spin", className: a.spin }, /* @__PURE__ */ e.createElement(r, null))
));
o.displayName = "Loader";
export {
  o as Loader
};
